import script from "./ContactsEmailPhoneOptionsDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactsEmailPhoneOptionsDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ContactsEmailPhoneOptionsDropdown.vue?vue&type=style&index=0&id=54afc56b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54afc56b"]])

export default __exports__